import {
    ADICIONAR_FILTRO_MANUTENCAO_VEICULO,
    LIMPAR_FILTRO_MANUTENCAO_VEICULO,
    REMOVER_FILTRO_MANUTENCAO_VEICULO
  } from '../../actions/types'
  import { filtroExiste } from '../../util/filtros'
  
  const initialState = undefined
  
  export const filtrosAdicionadosManutencaoVeiculo = (state = [], action = initialState) => {
    switch (action.type) {
      case ADICIONAR_FILTRO_MANUTENCAO_VEICULO: {
        if (!filtroExiste(state, action.payload)) {
          return state.concat(action.payload)
        }
        return state
      }
  
      case REMOVER_FILTRO_MANUTENCAO_VEICULO: {
        const copia = [...state]
        return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
      }
  
      case LIMPAR_FILTRO_MANUTENCAO_VEICULO: {
        return []
      }
  
      default:
        return state
    }
  }
  